import {StandardDaysComponent} from '../standardDays/standardDays.component';
import {SubmitComponent} from '../submit/submit.component';

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from '../login/login.component';
import {LogoutComponent} from '../logout/logout.component';
import {KantineComponent} from '../Canteen/canteen.component';
import {StatisticsCanteenComponent} from '../StatisticsCanteen/statisticsCanteen.component';
import {SecretaryComponent} from '../Secretary/secretary.component';
import {HRAndFinanceComponent} from '../HRAndFinance/HRAndFinance.component';
import {LiveComponent} from '../Live/live.component';
import {TelfortComponent} from '../Telfort/telfort.component';

const routes: Routes = [
  {path: '', redirectTo: 'aanmelden', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'aanmelden', component: SubmitComponent},
  {path: 'standaardDagen', component: StandardDaysComponent},
  {path: 'live', component: LiveComponent},
  {path: 'logout', component: LogoutComponent},
  {path: 'kantine', component: KantineComponent},
  {path: 'statistieken', component: StatisticsCanteenComponent},
  {path: 'secretariaat', component: SecretaryComponent},
  {path: 'HRFinance', component: HRAndFinanceComponent},
  {path: 'Telfort', component: TelfortComponent},


  {path: '**', redirectTo: '/', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/App/app-routing.module.ts